export default __webpack_public_path__ + "static/media/terms.04a68e8f.pdf";